import { a as languages } from "../../core-8vQkh0Rd.js";
import { t as createT4 } from "../../t4-templating-BDUium7S.js";
import "./vbnet.js";
//#region src/prism/languages/t4-vb.js
languages["t4-vb"] = createT4("vbnet");
//#endregion

//# sourceMappingURL=t4-vb.js.map